export default function present ({ state, actions }) {
  const emailErrorMessage =
    state.submittedOnce && state.emailValidation?.message;
  const passwordErrorMessage =
    state.submittedOnce && state.passwordValidation?.message;
  const signInCtaText = state.submitting ? 'Signing In...' : 'Sign In';
  const signInCtaDisabled = state.submitting;

  const resetPasswordMessage = 'Success! We have reset your password.';
  const forgotPasswordMessage =
    'You should receive an email with a link to reset your password';

  const successMessage = state.showResetPasswordSuccessMsg
    ? resetPasswordMessage
    : state.showForgotPasswordSuccessMsg
    ? forgotPasswordMessage
    : '';

  return {
    actions: {
      ...actions,
      changeEmail: actions.handleEmailChange,
      changePassword: actions.handlePasswordChange,
      submit: actions.handleSubmit,
      clickForgotPassword: actions.handleForgotPassword,
    },
    state: {
      ...state,
      email: {
        value: state.email,
        valid: !emailErrorMessage,
        message: emailErrorMessage,
      },
      password: {
        value: state.password,
        valid: !passwordErrorMessage,
        message: passwordErrorMessage,
      },
      signInCtaDisabled,
      signInCtaText,
      successMessage,
    },
  };
}
